import find from 'lodash/find';
import filter from 'lodash/filter';
import forEach from 'lodash/forEach';
import isEmpty from 'lodash/isEmpty';
import isUndefined from 'lodash/isUndefined';
import isNull from 'lodash/isNull';
import remove from 'lodash/remove';
import clamp from 'lodash/clamp';
import extend from 'lodash/extend';
import mapValues from 'lodash/mapValues';
import round from 'lodash/round';

module.exports = {find, filter, forEach, isEmpty, isUndefined, isNull, remove, clamp, extend, mapValues, round};



// WEBPACK FOOTER //
// ./src/common/customLodash.js